"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.GridContext = void 0;
exports.GridProvider = GridProvider;
var react_1 = __importStar(require("react"));
var api_1 = require("../api");
var utils_1 = require("../utils");
exports.GridContext = (0, react_1.createContext)({
    localRecords: [],
    keyword: "",
    setKeyword: function (kwd) { },
    pageNum: 1,
    pageSize: 10,
    updateRecord: function (id, props) {
        console.log(id, props);
    },
    totalPageNum: 1,
    setPageSize: function (num) { },
    gotoPageNum: function (num) { },
    gotoNextPage: function (num) { },
    forceReload: function () { },
});
function GridProvider(_a) {
    var children = _a.children;
    var _b = (0, react_1.useState)([]), localRecords = _b[0], setLocalRecords = _b[1];
    var _c = (0, react_1.useState)(""), keyword = _c[0], setKeyword = _c[1];
    var _d = (0, react_1.useState)(1), pageNum = _d[0], setPageNum = _d[1];
    var _e = (0, react_1.useState)(10), pageSize = _e[0], setPageSize = _e[1];
    var _f = (0, react_1.useState)(1), totalPageNum = _f[0], setTotalPageNum = _f[1];
    var _g = (0, react_1.useState)(0), vNum = _g[0], setVNum = _g[1];
    (0, react_1.useEffect)(function () {
        (0, api_1.fetchRecords)(pageNum, pageSize, keyword).then(function (data) {
            setLocalRecords(data.items);
            setTotalPageNum(data.page_count);
        });
    }, [pageNum, pageSize, keyword, vNum]);
    function updateRecord(id, props) {
        setLocalRecords(function (_records) {
            return _records.map(function (rec) { return (rec.id === id ? __assign(__assign({}, rec), props) : rec); });
        });
    }
    function gotoPageNum(num) {
        setPageNum((0, utils_1.clip)(num, 1, totalPageNum));
    }
    function gotoNextPage(num) {
        setPageNum(function (_pageNum) { return (0, utils_1.clip)(_pageNum + num, 1, totalPageNum); });
        console.log("gotoNextPage", num, pageNum);
    }
    function forceReload() {
        setVNum(function (v) { return v + 1; });
    }
    var gridValue = {
        localRecords: localRecords,
        keyword: keyword,
        setKeyword: setKeyword,
        updateRecord: updateRecord,
        pageNum: pageNum,
        pageSize: pageSize,
        totalPageNum: totalPageNum,
        setPageSize: setPageSize,
        gotoPageNum: gotoPageNum,
        gotoNextPage: gotoNextPage,
        forceReload: forceReload,
    };
    return react_1.default.createElement(exports.GridContext, { value: gridValue }, children);
}
